import moment from 'moment';

/**
 * Validates that the given date is not in past.
 *
 * @param {Date} value
 * @returns {boolean}
 */
export const cannotBeInPast = (value) => {
    const date = moment(value);

    return !date.isSameOrBefore(new Date());
};

/**
 * Validates that the given value resembles phone number
 *
 * @param {String} value
 * @returns {boolean}
 */
export const isPhoneNumber = (value) => {
    const phoneRegexp = /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/; // eslint-disable-line no-useless-escape
    return phoneRegexp.test(String(value).toLowerCase());
};

/**
 * Validates that the given date is numberOfDays amount in future.
 *
 * @param {int} numberOfDays
 * @returns {function(*=)}
 */
export const mustBeInFuture = (numberOfDays) => {
    return (value) => {
        const date = moment(value);
        const today = moment();

        return date.isAfter(today.add(numberOfDays, 'days'));
    };
};
